$(function() {
  // We want to show ads to blog readers on mobile. But our ads are in the sidebar,
  // which isn't visible at smaller screen sizes. The solution is to use JS to copy
  // sidebar ads and place them throughout the blog post, just before headings. We use
  // regular CSS (provided elsewhere) to show/hide based on screen size.
  function copyAdsFromSidebarToInline() {
    const article = document.querySelector('.c-blog-post>article');

    if (!article) return;

    const headings = Array.from(article.children).filter(child =>
      child.tagName.match(/^h\d$/i),
    );

    const ads = document.querySelectorAll('.c-very-special-messages__item');

    const headingsPerAd = 3;
    const firstHeadingWithAd = 2;
    const numHeadings = headings.length;
    const numAds = ads.length;

    for (
      let headingIndex = firstHeadingWithAd, adIndex = 0;
      headingIndex < numHeadings && adIndex < numAds;
      headingIndex += headingsPerAd, adIndex += 1
    ) {
      article.insertBefore(
        ads[adIndex].cloneNode(true),
        headings[headingIndex],
      );
    }
  }

  copyAdsFromSidebarToInline();
});
